import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

export function MaskLines({
    lines,
    className = "",
    lineClass = "",
    delay = 0,
    step = 0.12,
    once = true,
    mount = false,
}) {
    return (
        <motion.span
            className={className}
            initial="hidden"
            {...(mount ? { animate: "show" } : { whileInView: "show", viewport: { once, amount: 0.1 } })}
        >
            {lines.map((l, i) => (
                <span
                    key={i}
                    className="block overflow-hidden pb-[0.09em] -mb-[0.09em]"
                >
                    <motion.span
                        className={`block will-change-transform ${lineClass}`}
                        variants={{ hidden: { y: "112%" }, show: { y: 0 } }}
                        transition={{ duration: 0.9, ease: EASE, delay: delay + i * step }}
                        dangerouslySetInnerHTML={{ __html: l }}
                    />
                </span>
            ))}
        </motion.span>
    );
}

export function Crosshair({ className = "text-mist" }) {
    return (
        <svg viewBox="0 0 12 12" className={`h-3 w-3 ${className}`} aria-hidden="true">
            <path d="M6 0v12M0 6h12" stroke="currentColor" strokeWidth="1" />
        </svg>
    );
}
